/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteWidget} from '../api'

export const useMutationDeleteWidget = createReactQueryMutationHook('deleteWidget', deleteWidget)
